export default {
  SET_UNITS(state, units) {
    state.units = units;
  },
};
